export const CONTACT_TOPICS = [
    'General question',
    'Sales and pricing',
    'Product support',
    'Partnerships',
    'Press and media'
]

export const COMPANY_SIZES = [
    '1 to 10 people',
    '11 to 50 people',
    '51 to 200 people',
    '201 to 1,000 people',
    'More than 1,000 people'
]

export const INDUSTRIES = [
    'Software and SaaS',
    'E-commerce and retail',
    'Professional services',
    'Healthcare',
    'Financial services',
    'Manufacturing',
    'Nonprofit',
    'Other'
]

export const CURRENT_TOOLS = [
    'QuickBooks',
    'Xero',
    'NetSuite',
    'Sage Intacct',
    'Excel or Google Sheets',
    'Stripe',
    'Gusto or Rippling',
    'Other'
]

export const MEETING_TIMES = [
    'Morning (9am to 12pm)',
    'Afternoon (12pm to 4pm)',
    'Late afternoon (4pm to 6pm)',
    'Any time works'
]

export const PLAN_OPTIONS = [
    { value: 'starter', label: 'Starter' },
    { value: 'growth', label: 'Growth' },
    { value: 'enterprise', label: 'Enterprise' }
]

export const PLAN_INTERESTS = [
    'Not sure yet',
    'Starter',
    'Growth',
    'Enterprise'
]
